import React, { useState } from "react";
import {
  Button,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

const blank = () => ({
  description: "",
  quantity: 1,
  unitPrice: "",
  unitCost: "",
  markupPct: "",
});

export default function AdHocLineForm({ disabled, onAdd }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(blank());
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  if (!open) {
    return (
      <Button variant="outlined" disabled={disabled} onClick={() => { setDraft(blank()); setError(""); setOpen(true); }}>
        Add ad-hoc line
      </Button>
    );
  }

  const submit = async () => {
    if (!draft.description.trim()) { setError("Description is required"); return; }
    if (draft.unitPrice === "" || Number(draft.unitPrice) < 0) { setError("Unit price is required (>= 0)"); return; }
    const body = {
      description: draft.description.trim(),
      quantity: String(Number(draft.quantity) || 0),
      unitPrice: String(Number(draft.unitPrice) || 0),
    };
    if (draft.unitCost !== "") body.unitCost = String(Number(draft.unitCost) || 0);
    if (draft.markupPct !== "" && draft.unitCost === "") body.markupPct = String(Number(draft.markupPct) || 0);
    try {
      setSaving(true);
      setError("");
      await onAdd(body);
      setOpen(false);
    } catch (e) {
      setError(e.message || "Add failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 2 }}>New ad-hoc line</Typography>
      <Stack spacing={2}>
        {error && <Typography color="error">{error}</Typography>}
        <TextField
          label="Description" required fullWidth size="small"
          value={draft.description}
          onChange={(e) => setDraft({ ...draft, description: e.target.value })}
        />
        <Stack direction="row" spacing={2}>
          <TextField
            label="Quantity" type="number" inputProps={{ min: 0 }} fullWidth size="small"
            value={draft.quantity}
            onChange={(e) => setDraft({ ...draft, quantity: e.target.value })}
          />
          <TextField
            label="Unit Price" type="number" inputProps={{ min: 0 }} required fullWidth size="small"
            value={draft.unitPrice}
            onChange={(e) => setDraft({ ...draft, unitPrice: e.target.value })}
          />
          <TextField
            label="Unit Cost (optional)" type="number" inputProps={{ min: 0 }} fullWidth size="small"
            value={draft.unitCost}
            onChange={(e) => setDraft({ ...draft, unitCost: e.target.value })}
            helperText="If set, markup % is auto-derived"
          />
          <TextField
            label="Markup % (if no cost)" type="number" fullWidth size="small"
            value={draft.markupPct}
            onChange={(e) => setDraft({ ...draft, markupPct: e.target.value })}
            disabled={draft.unitCost !== ""}
          />
        </Stack>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={submit} disabled={saving}>
            {saving ? "Adding…" : "Add line"}
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
